import { render, staticRenderFns } from "./BaseCurrencyInput.vue?vue&type=template&id=6e51e752&scoped=true"
import script from "./BaseCurrencyInput.vue?vue&type=script&lang=js"
export * from "./BaseCurrencyInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e51e752",
  null
  
)

export default component.exports